const daysWeek = ['dl', 'dt', 'dc', 'dj', 'dv', 'ds', 'dg']
export default daysWeek



/** WEBPACK FOOTER **
 ** ./src/data/daysWeek.js
 **/